import React from 'react'
import { Layout, Row, Col } from 'antd'
import { AppHeader } from '../common/appHeader'
import { SideNav } from '../common/sideNav';
import { PageChatInterface } from '../common/pageChatInterface';
import { StyledContent, StyledLayout, StyledSider, SiderRow } from './mainLayout.styles';
import { HeaderType } from '../../../constants/enums';
import { getAppHeaderType } from '../../../../utility/appUtil';
const { Header } = Layout

const MainLayout = (props: any) => {
  const { children, logoutCallback, appUser } = props;
  
  // Determine if we should show the chat interface based on the current page and user context
  const shouldShowChat = () => {
    if (!appUser) return false;
    
    const path = window.location.pathname;
    
    // Don't show chat on settings, account settings, or public pages
    if (path.includes('/settings/') || 
        path.includes('/accountSettings/') || 
        path.includes('/organisation/') ||
        path.includes('/login') ||
        path.includes('/forgot-password') ||
        path.includes('/reset-password') ||
        path.includes('/create-password') ||
        path.includes('/validate-email')) {
      return false;
    }
    
    // Check if we're in JUNTO_PORTAL mode (where JuntoBlackSideBarItems are shown)
    const headerType = getAppHeaderType(appUser);
    if (headerType !== HeaderType.JUNTO_PORTAL) {
      return false;
    }
    
    // Show chat on main pages where JuntoBlackSideBarItems are typically rendered
    // This covers all the routes defined in JuntoBlackSideBarItems
    return path.startsWith('/user/dashboard') || 
           path.startsWith('/devices/health') || 
           path.startsWith('/devices/components') ||
           path.startsWith('/devices/configuration') ||
           path.startsWith('/workItems') || 
           path.startsWith('/alert/centre') || 
           path.startsWith('/insights') || 
           path.startsWith('/logs/eventLogs') ||
           path.startsWith('/eventLogs') ||
           // Also include device management routes
           path.startsWith('/device/devices') ||
           // Include any other routes that might use JuntoBlackSideBarItems
           path.startsWith('/user/') ||
           path.startsWith('/devices/') ||
           path.startsWith('/workItems/') ||
           path.startsWith('/alert/') ||
           path.startsWith('/insights/') ||
           path.startsWith('/logs/') ||
           path.startsWith('/eventLogs/');
  };
  
  return (
    <StyledLayout >
      <Row>
        <Col span={24}>
          <Header >
            <AppHeader {...props} logoutCallback={logoutCallback} />
          </Header>
        </Col>
      </Row>
      <SiderRow>
        <Col span={6} lg={4}>
          <StyledSider>
            {<SideNav {...props} />}
          </StyledSider>
        </Col>
        <Col span={18} lg={20}>
          <StyledContent
          >
            {children}
          </StyledContent>
        </Col>
      </SiderRow>
      
      {/* Page Chat Interface - shows when JuntoBlackSideBarItems are rendered */}
      {/* <PageChatInterface showChat={shouldShowChat()} /> */}
    </StyledLayout>
  )
}

export default MainLayout
